import { AsyncState, Updater } from 'widgets-for-react'
import { ImageData } from '../../image/imageState'
import { loadComponentTeasers } from './componentTeasersApi'

export type ExtendedComponentTeasersState = ComponentTeasersState & {
  saveComponentId: number | 'none'
}

export type ComponentTeasersState = AsyncState<ComponentTeaserData[]>

export type ComponentTeaserData = {
  Id: number
  Name: string
  ImageURL: ImageData
  IsUserComponent: boolean
  IsDraft: boolean
}

export const initialComponentTeasersState = (
  apicall: () => Promise<any>
): ComponentTeasersState => loadComponentTeasers(apicall)

export const componentTeasersStateUpdaters = {
  componentTeasersStateUpdater:
    (updater: Updater<ComponentTeasersState>) =>
    (state: ComponentTeasersState): ExtendedComponentTeasersState => ({
      ...updater(state),
      saveComponentId: 'none',
    }),
  saveComponentIdUpdater:
    (saveComponentId: number) =>
    (state: ComponentTeasersState): ExtendedComponentTeasersState => ({
      ...state,
      saveComponentId: saveComponentId,
    }),
}
